/*eslint-disable */
define(
    ["jquery"],
    function($) {
        return function scrollTo(elementOrPosition, speed, callback) {
            var position;

            if (typeof elementOrPosition === "number") {
                position = elementOrPosition;
            } else {
                position = $(elementOrPosition).offset().top;
            }

            var $elements = $("html:not(:animated), body:not(:animated)");
            var completedCount = 0;

            $elements.
                animate(
                    {scrollTop: position},
                    speed || 200,
                    function() {
                        if (callback) {
                            completedCount++;

                            if (completedCount === $elements.length) {
                                callback();
                            }
                        }
                    }
                );
        };
    }
);
